import React from 'react'
import {
  Box,
  Grid,
  Typography,
  useTheme,
  Container,
  Avatar,
} from '@mui/material'
import Qoute_icon from '../../Assets/Icons/qoute.svg'
import aboutUsData from '../../Assets/JSON/Aboutus/aboutUsData.json'

const About_us = () => {
  const theme = useTheme()

  return (
    <Box sx={{ backgroundColor: theme.palette.background.whiteBackground }}>
      <Container maxWidth="lg" sx={{ py: 6 }}>
        {/* Quote Section */}
        <Box
          sx={{
            textAlign: 'center',
            mb: 4,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            gap: { xs: 1, sm: 2, md: 3 },
            flexWrap: 'wrap',
            p: { xs: 2, sm: 3 },
          }}
        >
          <img src={Qoute_icon} alt="Quote Icon" style={{ height: '40px' }} />
          <Typography
            variant="h5"
            sx={{
              fontWeight: 'bold',
              color: theme.palette.text.main,
              fontFamily: theme.typography.h5.fontFamily,
              fontSize: { xs: '1.2rem', sm: '1.5rem', md: '2rem' },
            }}
          >
            {aboutUsData.quote}
          </Typography>
          <img
            src={Qoute_icon}
            alt="Quote Icon"
            style={{ height: '40px', transform: 'scaleX(-1)' }}
          />
        </Box>

        {/* Founder Section */}
        <Grid container spacing={4} sx={{ mt: 6 }}>
          <Grid item xs={12} md={6} textAlign="center">
            <Avatar
              src={aboutUsData.founder.image}
              variant="rounded"
              sx={{
                width: { xs: '100%', sm: 400 },
                height: 'auto',
                mx: 'auto',
                borderRadius: 2,
              }}
            />
            <Typography
              variant="h4"
              sx={{
                fontWeight: 'bold',
                mt: 2,
                color: theme.palette.text.primary,
              }}
            >
              {aboutUsData.founder.name}
            </Typography>
            <Typography
              variant="body2"
              sx={{ color: theme.palette.text.accent }}
            >
              {aboutUsData.founder.title}
            </Typography>
          </Grid>
          <Grid item xs={12} md={6}>
            <Typography
              variant="h5"
              component="h4"
              sx={{
                fontWeight: 'bold',
                mb: 2,
                color: theme.palette.text.primary,
              }}
            >
              About The Founder
              <Box
                sx={{
                  width: 70,
                  height: 4,
                  backgroundColor: theme.palette.primary.main,
                }}
              />
            </Typography>
            <Typography
              variant="body1"
              sx={{
                textAlign: 'justify',
                color: theme.palette.text.paragraph,
              }}
            >
              {aboutUsData.founder.description}
            </Typography>
          </Grid>
        </Grid>

        {/* Institute History */}
        <Grid container spacing={4} sx={{ mt: 8 }}>
          <Grid item xs={12} md={6}>
            <img
              src={aboutUsData.instituteHistory.image}
              alt="Campus"
              style={{
                width: '100%',
                borderRadius: 8,
                boxshadow: '0 4px 12px rgba(0, 0, 0, 0.3)',
              }}
            />
          </Grid>
          <Grid item xs={12} md={6}>
            <Typography
              variant="h4"
              sx={{
                fontWeight: 'bold',
                mb: 2,
                color: theme.palette.text.primary,
              }}
            >
              {aboutUsData.instituteHistory.title}
              <Box
                sx={{
                  width: 70,
                  height: 4,
                  backgroundColor: theme.palette.primary.main,
                }}
              />
            </Typography>
            <Typography
              variant="body1"
              sx={{ textAlign: 'justify', color: theme.palette.text.paragraph }}
            >
              {aboutUsData.instituteHistory.description}
            </Typography>
          </Grid>
        </Grid>

        {/* Team Section */}
        <Box mt={10}>
          <Box sx={{ textAlign: 'center', mb: 4 }}>
            <Typography
              variant="h4"
              component="h4"
              sx={{
                fontWeight: 'bold',
                color: theme.palette.text.primary,
                textDecoration: 'underline',
                textDecorationColor: theme.palette.primary.main,
                textDecorationThickness: 4,
                textUnderlinePosition: 'under',
              }}
            >
              Meet the Founders
            </Typography>
          </Box>
          <Grid container spacing={4}>
            {aboutUsData.employees.map((emp, index) => (
              <Grid item xs={12} sm={6} md={3} key={index}>
                <Box
                  sx={{
                    textAlign: 'center',
                    borderRadius: 2,
                    py: 3,
                    px: 2,
                  }}
                >
                  <Avatar
                    src={emp.image_path}
                    variant="rounded"
                    sx={{
                      width: { xs: '100%', sm: 250 },
                      height: 'auto',
                      mx: 'auto',
                      borderRadius: 2,
                    }}
                  />
                  <Typography
                    variant="h6"
                    sx={{ mt: 2, color: theme.palette.text.main }}
                  >
                    {emp.employe_name}
                  </Typography>
                  <Typography
                    variant="body2"
                    sx={{ color: theme.palette.text.secondary }}
                  >
                    {emp.designation}
                  </Typography>
                  <Typography
                    variant="body2"
                    sx={{ color: theme.palette.text.muted }}
                  >
                    {emp.description}
                  </Typography>
                </Box>
              </Grid>
            ))}
          </Grid>
        </Box>
      </Container>
    </Box>
  )
}

export default About_us
